import { lazy } from 'react'
import { RouteObject } from 'react-router-dom'
import Loadable from '@/components/Loadable'

const ConexaAdmin = Loadable(
  lazy(() => import('../pages/ConexaAdmin')),
  true,
)

const AdminClinic = Loadable(
  lazy(() => import('../pages/AdminClinic')),
  true,
)

const Patient = Loadable(
  lazy(() => import('../pages/Patient')),
  true,
)

const PatientAttendance = Loadable(
  lazy(
    () => import('../pages/Patient/components/Attending/Attending.component'),
  ),
  true,
)

const LinkedPsychologists = Loadable(
  lazy(() => import('../pages/Patient/components/LinkedPsychologists')),
  true,
)

const Attendance = Loadable(
  lazy(
    () => import('../pages/Patient/components/Attending/Attending.component'),
  ),
  true,
)

const Detective = Loadable(
  lazy(
    () =>
      import(
        '@/modules/Users/pages/Patient/components/Attending/components/Detective/Detective.component'
      ),
  ),
  true,
)

const UserManagement = Loadable(
  lazy(() => import('../pages/ConexaAdmin/components/UserManagement')),
  true,
)

const AddUserAdminClinic = Loadable(
  lazy(() => import('../pages/AdminClinic/components/UserManagement')),
  true,
)

const ServiceDetails = Loadable(
  lazy(
    () =>
      import('../pages/Patient/components/Attending/components/ServiceDetails'),
  ),
  true,
)

const CallDetails = Loadable(
  lazy(
    () =>
      import(
        '../pages/Patient/components/Attending/components/ServiceDetails/components/CallDetails'
      ),
  ),
  true,
)

const RegisterPatient = Loadable(
  lazy(
    () =>
      import(
        '../pages/Patient/components/RegisterPatient/RegisterPatient.page'
      ),
  ),
  true,
)
const AffiliatedClinics = Loadable(
  lazy(
    () =>
      import(
        '../pages/Professional/components/AffiliatedClinics/AffiliatedClinics.page'
      ),
  ),
  true,
)

const FinancialManagement = Loadable(
  lazy(
    () =>
      import(
        '../pages/Professional/FinancialManagement/FinancialManagement.page'
      ),
  ),
  true,
)

const PlansAndSessions = Loadable(
  lazy(
    () =>
      import('../pages/Professional/PlansAndSessions/PlansAndSessions.page'),
  ),
  true,
)

const Contracts = Loadable(
  lazy(() => import('../pages/Professional/Contracts/Contracts.page')),
  true,
)

const Permission = Loadable(
  lazy(() => import('../pages/Professional/Permission/Permission.page')),
  true,
)

const SmartQueueStatus = Loadable(
  lazy(
    () =>
      import('../pages/Professional/SmartQueueStatus/SmartQueueStatus.page'),
  ),
  true,
)

const ProfessionalData = Loadable(
  lazy(
    () =>
      import('../pages/Professional/ProfessionalData/ProfessionalData.page'),
  ),
  true,
)

const Professionals = Loadable(
  lazy(() => import('../pages/Professional/Professionals/Professionals.page')),
  true,
)

const ProfessionalAgenda = Loadable(
  lazy(() => import('../pages/Professional/Agenda/Agenda.page')),
  true,
)

const UsersRoutes: RouteObject = {
  path: 'usuario',
  children: [
    {
      path: 'pacientes/atendimentos/detalhes-do-atendimento/:userId',
      element: <ServiceDetails />,
    },
    {
      path: 'detalhes-atendimento/detalhes-consulta/:id',
      element: <CallDetails />,
    },
    {
      path: 'admin-clinica',
      element: <AdminClinic />,
    },
    {
      path: 'admin-clinica/usuario',
      element: <AddUserAdminClinic />,
    },
    {
      path: 'admin-clinica/usuario/:userId',
      element: <AddUserAdminClinic />,
    },
    {
      path: 'pacientes/atendimentos/:id',
      element: <PatientAttendance />,
    },
    {
      path: 'pacientes/atendimentos/detetive/:patientId/:appointmentId',
      element: <Detective />,
    },
    {
      path: 'pacientes/psicologos-vinculados/:id',
      element: <LinkedPsychologists />,
    },
    {
      path: 'pacientes/atendimentos',
      element: <Attendance />,
    },
    {
      path: 'detalhes-atendimento/detalhes-consulta/:id',
      element: <CallDetails />,
    },
    {
      path: 'admin-conexa',
      element: <ConexaAdmin />,
    },
    {
      path: 'pacientes',
      element: <Patient />,
    },
    {
      path: 'admin-conexa/usuario',
      element: <UserManagement />,
    },
    {
      path: 'admin-conexa/usuario/:userId',
      element: <UserManagement />,
    },
    {
      path: 'pacientes/cadastrar',
      element: <RegisterPatient />,
    },
    {
      path: 'pacientes/editar/:id',
      element: <RegisterPatient />,
    },
    {
      path: 'profissional',
      element: <ProfessionalData />,
    },
    {
      path: 'profissionais/clinicas-vinculadas/:id',
      element: <AffiliatedClinics />,
    },
    {
      path: 'profissional/:professionalId/:userId/financeiro',
      element: <FinancialManagement />,
    },
    {
      path: 'profissional/:id/planos-e-sessoes',
      element: <PlansAndSessions />,
    },
    {
      path: 'profissional/:id/contratos',
      element: <Contracts />,
    },
    {
      path: 'profissional/:id/permissoes',
      element: <Permission />,
    },
    {
      path: 'profissional/:id/status-fila-inteligente',
      element: <SmartQueueStatus />,
    },
    {
      path: 'profissionais',
      element: <Professionals />,
    },
    {
      path: 'profissional/agenda',
      element: <ProfessionalAgenda />,
    },
  ],
}

export default UsersRoutes
